import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-notifications-panel',
  standalone: false,
  templateUrl: './notifications-panel.component.html',
  styleUrl: './notifications-panel.scss'
})
export class NotificationsPanelComponent {
  @Output() onVerTodas = new EventEmitter<void>();
}
